import React from 'react';
// @mui
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// component
import Iconify from 'src/components/iconify';

interface ICasIconButton {
  icon: string | JSX.Element;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  height?: number;
  width?: number;
  visibility?: 'inherit' | 'hidden';
  display?: 'inherit' | 'none';
  color?:
    | 'inherit'
    | 'default'
    | 'error'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning';
  tooltip?: string;
}

export default function CasIconButton({
  icon,
  onClick,
  disabled = false,
  width = 25,
  height = 25,
  visibility = 'inherit',
  display = 'inherit',
  color = 'inherit',
  tooltip = '',
}: ICasIconButton) {
  const iconElement =
    typeof icon === 'string' ? (
      <Iconify icon={icon} width={width} height={height} />
    ) : (
      React.cloneElement(icon, {
        style: { width, height, fontSize: width, color },
      })
    );

  return (
    <Tooltip title={tooltip} disableHoverListener={!tooltip}>
      <IconButton
        color={color}
        onClick={onClick}
        disabled={disabled}
        sx={{
          padding: 0,
          opacity: 0.48,
          visibility,
          display,
          '&:hover': {
            opacity: 1,
          },
        }}
      >
        {iconElement}
      </IconButton>
    </Tooltip>
  );
}
